<template>
    <div id="main">
        <Breadcrumb :currentPage="breadcrumbName" :items="breadcrumbItems" :showAddBtn="false"/>
        <Dialog ref="ratingDialog"/>
        <!--Upload partition-->
        <v-layout row wrap>
            <v-flex xs12 md4>
                <v-layout row wrap>
                    <v-flex d-flex>
                        <v-card class="mx-auto">
                            <GalleryImage/>
                            <v-card-actions>
                                <div style="width: 100%">
                                    <v-btn
                                        @click="generate"
                                        color="primary"
                                        style="width: 40%"
                                    >Generate
                                    </v-btn>
                                </div>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                    <v-flex d-flex v-if="visibleRating">
                        <!--Rating card-->
                        <v-card class="mx-auto">
                            <v-card-title>
                                <b>Rating</b>
                            </v-card-title>
                            <v-card-actions>
                                <v-form v-model="valid" style="width: 100%">
                                    <v-container>
                                        <v-rating
                                            v-model="rating"
                                            style="margin-top: -10%"
                                            background-color="orange lighten-3"
                                            color="orange"
                                        ></v-rating>
                                        <v-text-field v-model="comment" label="Type your comment" single-line
                                                      solo></v-text-field>
                                        <v-btn
                                            @click="submitRating"
                                            color="primary"
                                            style="display: inline-flex; width: 5%"
                                        >
                                            <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                                                <path
                                                    fill="#ffffff"
                                                    d="M9.78,18.65L10.06,14.42L17.74,7.5C18.08,7.19 17.67,7.04 17.22,7.31L7.74,13.3L3.64,12C2.76,11.75 2.75,11.14 3.84,10.7L19.81,4.54C20.54,4.21 21.24,4.72 20.96,5.84L18.24,18.65C18.05,19.56 17.5,19.78 16.74,19.36L12.6,16.3L10.61,18.23C10.38,18.46 10.19,18.65 9.78,18.65Z"
                                                />
                                            </svg>
                                        </v-btn>
                                    </v-container>
                                </v-form>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 md8>
                <v-card height="500px">
                    <v-card-title>
                        <b>Module 3D</b>
                    </v-card-title>
                    <div v-if="disclaimer" class="disclaimer">
                        <img :src="icon" alt="">
                        <div class="disclaimer-content">
                            <p>Model results may not be good</p>
                            <p>because the image is not up to standard</p>
                        </div>
                    </div>
                    <Viewer3d :mesh="meshFile" class="viewer-3d"/>
                    <p v-if="disclaimer" class="drag-spin">Drag to spin the model</p>
                </v-card>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import axios from "axios";
    import Const from "../const.js";
    import Breadcrumb from '../components/common/Breadcrumb.vue';
    import GalleryImage from "../components/GalleryImage"
    import Viewer3d from "../components/Viewer3d.vue";
    import {mapActions, mapGetters} from 'vuex'
    import {getBase64fromUrl} from "../utils/category";

    export default {
        name: "gallery",
        data() {
            return {
                breadcrumbName: "Samples",
                breadcrumbItems: [
                    {
                        text: "samples",
                        disabled: true,
                        to: {path: "/samples"},
                        exact: true
                    }
                ],
                visibleRating: false,
                rating: 0,
                comment: "",
                valid: false,
                meshId: "",
                meshFile: "",
                selectedImages: [],
                errors: [],
                icon: require('../assets/disclamer.svg'),
                disclaimer: false,
                dialog: false
            };
        },
        components: {
            Breadcrumb,
            Viewer3d,
            GalleryImage,
        },
        methods: {
            ...mapGetters('gallery',[
                'getSelectedImage'
            ]),
            ...mapActions('app', [
                'initSnackbar'
            ]),
            toogleImage(){

            },
            submitRating: function () {
                if (this.valid === true) {
                    this.$root.$dialogLoader.start("Submitting ...", {color: "primary"}, {}, true);
                    axios
                        .post(Const.SERVER_ADDR + "debuglog/rating", {
                            mesh_id: this.meshId,
                            rate: this.rating,
                            comment: this.comment,
                        })
                        .then(response => {
                            // Show message response.data.title + response.data.message
                            this.$refs.ratingDialog.dialogShow = true;
                            this.$refs.ratingDialog.title = response.data.title;
                            this.$refs.ratingDialog.message = response.data.message;
                            this.$root.$dialogLoader.stop("3D model generated", {timeout: 10000}, {});
                        })
                        .catch(e => {
                            this.$root.$dialogLoader.stop("Error", {timeout: 10000}, {});
                            this.errors.push(e);
                        });
                }
            },
            generate: function () {
                const links = this.getSelectedImage();
                if (links.length === 0) {
                    return this.initSnackbar({
                        message: 'You should select image',
                        color: 'error'
                    });
                } else {
                    let getData = links.map(img => {
                        return getBase64fromUrl(img).then(data => {
                            return data
                        })
                    });

                    Promise.all(getData).then(data => {
                        this.visibleRating = false;
                        this.$root.$dialogLoader.start(
                            "Generating ...",
                            {color: "primary"},
                            {},
                            true
                        );

                        axios.post(Const.SERVER_ADDR + "mesh/create", {
                            body: data
                        }).then(response => {
                            this.meshId = response.data.mesh_id;
                            this.meshFile = Const.SERVER_ADDR + response.data.mesh_url;
                            this.visibleRating = true;
                            this.$root.$dialogLoader.stop(
                                "3D model generated",
                                {timeout: 10000},
                                {}
                            );
                            this.disclaimer = true
                        }).catch(e => {
                            this.$root.$dialogLoader.stop("Error", {timeout: 10000}, {});
                            this.errors.push(e);
                        });
                    })
                }
            }
        }
    };
</script>

<style scoped>

    .disclaimer {
        margin-left: 0;
        padding-left: 16px;
        display: flex;
    }

    .disclaimer img {
        margin-left: 0;
        float: left;
    }

    .disclaimer-content p {
        margin-bottom: 0;
        text-align: left;
        color: #FF9F43;
        font-weight: 600;
        font-size: 0.8rem;
    }

    .viewer-3d {
        margin-top: 2rem;
        height: 70%;
    }

</style>
